import SimplePreview from './SimplePreview';

export default SimplePreview;
